<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>指針入力</h1>
<form *ngIf="sgke371arequestData" [formGroup]="sgke371arequestData">
    <div formGroupName="shishinInputInfo">
        <mat-card class="cur-card">
            <div class="tw-flex tw-flex-row">
                <mat-card-content style="margin-top: 1%; margin-left:1%;">
                    <mat-radio-group color="warn" [disabled]=false
                        class="customer-radio-group tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]"
                        style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
                        <mat-label
                            style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                            前回指針情報</mat-label>

                        <div class="tw-flex tw-flex-row justify-evenly" style="margin-top: 2%; margin-left:2%;">
                            <mat-form-field appearance="outline"
                                class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]"
                                style="margin-top: 2%; margin-left:2%;">
                                <mat-label class="text-glay-color">指針</mat-label>
                                <input matInput autocomplete="off" formControlName="supplysuspensiontimeShishin"
                                    class="text-black-color" style="text-align:right;" />
                            </mat-form-field>
                            <mat-form-field appearance="outline"
                                class="input-form-basic-info-other tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]"
                                style="margin-top: 2%; margin-left:2%;">
                                <mat-label class="text-glay-color">検針タイミング</mat-label>
                                <input class="text-black-color" [value]="diaData.kenshinTiming" matInput
                                    autocomplete="off" [disabled]=true id="kenshinTiming" />
                            </mat-form-field>
                        </div>
                    </mat-radio-group>
                </mat-card-content>

                <mat-card-content style="margin-top: 1%; margin-left:3%;">
                    <mat-radio-group color="warn" [disabled]=false
                        class="customer-radio-group tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[80%]"
                        style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
                        <mat-label
                            style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                            前回メーター情報</mat-label>

                        <div class="tw-flex tw-flex-row justify-evenly"
                            style="margin-top: 2%; margin-left:2%; display: block;">
                            <mat-form-field appearance="outline"
                                class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]"
                                style="margin-top: 2%; margin-left:2%;">
                                <mat-label class="text-glay-color">メーター番号</mat-label>
                                <input class="text-black-color" [value]="diaData.preMeterNo" matInput autocomplete="off"
                                    [disabled]=true id="preMeterNo" />
                            </mat-form-field>
                            <mat-form-field appearance="outline"
                                class="input-form-basic-info-other tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]"
                                style="margin-top: 2%; margin-left:2%;">
                                <mat-label class="text-glay-color">型</mat-label>
                                <input class="text-black-color" [value]="diaData.preMeterModel" matInput
                                    autocomplete="off" [disabled]=true id="preMeterModel" />
                            </mat-form-field>
                            <mat-form-field appearance="outline"
                                class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]"
                                style="margin-top: 2%; margin-left:2%;">
                                <mat-label class="text-glay-color">能力</mat-label>
                                <input class="text-black-color" [value]="diaData.preMeterAbility" matInput
                                    autocomplete="off" [disabled]=true id="preMeterAbility" />
                            </mat-form-field>
                        </div>
                    </mat-radio-group>
                </mat-card-content>
            </div>
        </mat-card>

        <mat-card class="cur-card">
            <div class="tw-flex tw-flex-row">
                <p>現在のメーター情報が、上記前回メーター情報と</p>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-radio-group id="actionType3" formControlName="meterInfoeqFlg" color="warn"
                        (change)="onChangeMeterMatch()">
                        <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                            *ngFor="let code of codeMap?.get('S301241')">{{code.hyojiCont}}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <!-- 一致 -->
            <div *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '1'" class="tw-flex tw-flex-row"
                style="width: 400px;">
                <mat-checkbox class="check-box"
                    style="padding-left: 30px; padding-top: 20px!important; padding-bottom: 30px;" color="primary"
                    formControlName="meterKaitenariFlg">
                    メーター回転あり
                </mat-checkbox>
            </div>

            <!-- 不一致 -->
            <div *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '0'" class="tw-flex tw-flex-row"
                style="width: 400px;">
                <mat-checkbox id="notificationFlg" formControlName="meterTorikaeariFlg"
                    (change)="onChangeMeterTorikae()" class="check-box"
                    style="padding-top: 10px; padding-bottom: 20px; padding-left: 30px;" color="primary">
                    メーター取替あり
                </mat-checkbox>
            </div>
            <div *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '0'" class="tw-flex tw-flex-row"
                style="min-width: 900px;">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]"
                    style="margin-right: 30px;">
                    <mat-label>取外メーター番号</mat-label>
                    <input class="font-color-display-only" matInput autocomplete="off" formControlName="removalMeterNo"
                        maxlength="10" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
                    <mat-label>取外時指針</mat-label>
                    <input class="font-color-display-only" matInput autocomplete="off"
                        formControlName="removalMeterShishin" type="number" style="text-align:right;"
                        [step]="diaData.energyClscode == '1' ? 1: 0.1" />
                </mat-form-field>
            </div>

            <div *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '0'" class="tw-flex tw-flex-row"
                style="min-width: 900px;">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]"
                    style="margin-right: 30px;">
                    <mat-label>取付メーター番号</mat-label>
                    <input class="font-color-display-only" formControlName="installationMeterNo" matInput
                        autocomplete="off" maxlength="10" />
                </mat-form-field>

                <mat-form-field *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '0'" appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
                    <mat-label>取付時指針</mat-label>
                    <input class="font-color-display-only" matInput autocomplete="off"
                        formControlName="installationMeterShishin" type="number" style="text-align:right;"
                        [step]="diaData.energyClscode == '1' ? 1: 0.1" />
                </mat-form-field>
            </div>

            <div *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '0'" class="tw-flex tw-flex-row"
                style="width: 400px;">
                <mat-checkbox class="check-box" style="padding-left: 30px; padding-bottom: 20px;" color="primary"
                    formControlName="meterKaitenariFlg">
                    メーター回転あり
                </mat-checkbox>
            </div>

            <div class="tw-flex tw-flex-row"
                *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '1' || shishinInputInfo.get('meterInfoeqFlg').value == '0'">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]">
                    <mat-label>今回指針</mat-label>
                    <input (blur)="changeDisabled($event)" formControlName="thistimeShishin" matInput autocomplete="off"
                        type="number" style="text-align:right;" [step]="diaData.energyClscode == '1' ? 1: 0.1" />
                </mat-form-field>

            </div>

            <div class="tw-flex tw-flex-row"
                *ngIf="shishinInputInfo.get('meterInfoeqFlg').value == '1' || shishinInputInfo.get('meterInfoeqFlg').value == '0'">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]">
                    <mat-label>今回指針(確認用)</mat-label>
                    <input formControlName="thistimeShishinForconfirm" matInput autocomplete="off" type="number"
                        style="text-align:right;" [step]="diaData.energyClscode == '1' ? 1: 0.1" />
                </mat-form-field>
            </div>
        </mat-card>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center"
            style="margin-right: 7%">
            <mat-card-actions>
                <button type="button" mat-raised-button color="primary" class="btn" (click)="close()">閉じる</button>
                <button type="button" mat-raised-button color="primary" class="btn" (click)="register()"
                    [disabled]="shishinInputInfo.get('meterInfoeqFlg')?.value == '1' ? shishinInputInfo.get('thistimeShishin')?.invalid || shishinInputInfo.get('thistimeShishinForconfirm')?.invalid: sgke371arequestData.invalid">登録</button>
            </mat-card-actions>
        </div>
    </div>
</form>